module.exports = function() {
  return new Worker(__webpack_public_path__ + "d5a14c75127965c093e9.worker.js");
};